import client from '../client';
import uuid from 'uuid';

export const ADD_BADGE = 'ADD_BADGE';
export const DELETE_BADGE = 'DELETE_BADGE';
export const EDIT_BADGE = 'EDIT_BADGE';
export const FETCH_BADGES = 'FETCH_BADGES';

export function addBadge(values) {
  const data = new FormData();
  if (values.image_id) data.append('image_id', values.image_id);
  if (values.image) data.append('image', values.image, uuid.v4());
  data.append('name', values.name);

  return {
    type: ADD_BADGE,
    promise: client.post('badges', data),
  };
}

export function deleteBadge(id) {
  return {
    type: DELETE_BADGE,
    promise: client.delete(`badges/${id}`),
    badgeId: id,
  };
}

export function editBadge(id, values) {
  const data = new FormData();
  if (values.image_id) data.append('image_id', values.image_id);
  if (values.image) data.append('image', values.image, uuid.v4());
  data.append('name', values.name);

  return {
    type: EDIT_BADGE,
    promise: client.put(`badges/${id}`, data),
  };
}

export function fetchBadges() {
  return {
    type: FETCH_BADGES,
    promise: client.get('badges'),
  };
}



// WEBPACK FOOTER //
// ./src/badges/actions.js